//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  data() {
    const that = this;
    return {
      swiperOptions: {
        slidesPerView: 7,
        spaceBetween: 10,
        slidesPerGroup: 7,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          click: function () {
            // this 指向的是 swpier 实例，而不是当前的 vue
            let index = this.clickedSlide.dataset.swiperSlideIndex;
            // this.clickedSlide.classList.add("swiper-slide-active");
            that.handleClickSlide(index);
          },
        },
      },
      assignWorks: {}, // 派活地块统计（地图底部信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    // 底部信息配置项
    mapBottomInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasMapBottomInfo: false, // 是否有底部信息
          hasAssignBtn: false, // 是否有派活按钮
          orderId: "", // 订单ID
          workTypeId: "", // 作业类型ID
        };
      },
    },
  },
  mounted() {
    this.getAssignWorks();
  },
  methods: {
    /**
     * @descripttion: 获取派活地块统计（地图底部信息）
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:32:00
     * @param {*}
     */
    getAssignWorks() {
      let { orderId, workTypeId: workType } = this.mapBottomInfoOptions;
      let params = { orderId, workType };
      this.$http.work.getAssignWorks(params).then((res) => {
        this.assignWorks = res.data;
      });
    },
    /**
     * @descripttion: 点击地图底部某一地块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:59:15
     * @param {*} index
     */
    handleClickSlide(index) {
      let id = this.assignWorks.assignWorkList[index].id;
      this.$bus.$emit("changeRightInfo", { show: true, name: "assignDetail" });
      this.$bus.$emit("getAssignDetail", { id });
    },
    /**
     * @descripttion: swiper右箭头
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:02:56
     */
    swiperNext() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    /**
     * @descripttion: swiper左箭头
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:03:13
     */
    swiperPrev() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    /**
     * @descripttion: 去派活
     * @Author: juanjuanhui
     * @Date: 2021-12-07 15:49:26
     * @param {*}
     */
    handleAssignWork() {
      this.$router.push({
        path: this.mapBottomInfoOptions.assignRouter,
        query: {
          orderId: this.mapBottomInfoOptions.orderId,
          workTypeId: this.mapBottomInfoOptions.workTypeId,
        },
      });
    },
  },
};
